class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.delay = this.dataset.delay;
    this.automaticModal = this.delay ? true : false;
    this.localStorageKey = 'AutomaticModal';

    // Access local storage to detect whether modal already been shown?
    this.showModal = localStorage.getItem(this.localStorageKey) != 'true';

    // Is the 'Always show modal in Theme Editor view' setting enabled?
    this.themeEditorView = this.dataset.themeEditorView == 'true';

    // If it is, and we're in the theme editor, we ensure this.showModal is set to true.
    if (this.themeEditorView && document.documentElement.classList.contains('shopify-design-mode')) {
      this.showModal = true;
    }

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    if (this.automaticModal && this.showModal) { // Show modal automatically
      setTimeout(() => {
        this.summaryToggle.click();
        localStorage.setItem(this.localStorageKey, 'true');
      }, Number(this.delay))
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);